import countries from '@swf/generated/countries.json';

export const countriesByCode = countries.reduce(
  (acc: { [key: string]: string }, item: { value: string; text: string }) => {
    const { text, value } = item;

    acc[value] = text;

    return acc;
  },
  {} as { [key: string]: string }
);
